import { ColumnDescription } from "react-bootstrap-table-next";
import { useRegistrarAcordoSiengeContext } from "..";
import Table from "../../../../../Components/Table";
import { IParcelasComDescontos } from "../../../../../Interfaces/Cobranca/Renegociacao/RenegociacaoInterfaces";
import { formatMoneyReais } from "../../../../../Tools/FormatTools";
import { MoneyReaisFieldMask } from "../../../../../Validations/InputMasks";
import { useForm } from "react-hook-form";
import moment from "moment";
import { Spinner } from "../../../../../Components/Loding/SpinnerPadrao";
import { ChangeEvent, useEffect } from "react";

export default function SimularParcela() {
    const {
        goToStep,
        lstSelecionados,
        lstSelecionadosParcelasGeradas,
        parcelaReq,
        setParcelaReq,
        SalvarSimulacao,
        RealizarRenegociacaoSiengeLoading,
    } = useRegistrarAcordoSiengeContext();

    const formMethods = useForm();

    const { handleSubmit, register, watch, setValue, getValues, errors } =
        formMethods;

    const somaAditivoEDesconto =
        Number(watch("aditivoPrc")) + Number(watch("descontoPrc"));

    const totalSelecionados = Number(
        lstSelecionados
            ?.reduce((sum, parcela) => sum + parcela.ValorReaj, 0.0)
            .toFixed(2) ?? 0
    );

    const totalGeradas = Number(
        lstSelecionadosParcelasGeradas
            ?.reduce((sum, parcela) => sum + parcela.ValorReaj, 0.0)
            .toFixed(2) ?? 0
    );

    const columnsParcelasOriginaisEReparceladas: Array<
        ColumnDescription<IParcelasComDescontos>
    > = [
        {
            dataField: "Descricao_par",
            text: "Parcela",
            classes: "p-3 ws-nowrap align-middle text-center",
            align: "center",
            headerAlign: "center",
            formatter: (c, row) => {
                const data = new Date(row.Data_Prc);
                return (
                    <span
                        className={
                            data.getTime() < Date.now() ? "text-danger" : ""
                        }
                    >
                        {row.idDescricao_par ? row.idDescricao_par : "-"} / {c}
                    </span>
                );
            },
        },
        {
            dataField: "ValorReaj",
            text: "Valor Corrigido",
            classes: "p-3 ws-nowrap align-middle text-center",
            align: "center",
            headerAlign: "center",
            formatter: (c, row) => {
                const data = new Date(row.Data_Prc);
                return (
                    <span
                        className={
                            data.getTime() < Date.now() ? "text-danger" : ""
                        }
                    >
                        {formatMoneyReais(c)}
                    </span>
                );
            },
        },
        {
            dataField: "Data_Prc",
            text: "Data de vencimento",
            classes: "p-3 ws-nowrap align-middle text-center",
            align: "center",
            headerAlign: "center",
            formatter: (c) => {
                const data = new Date(c);
                return (
                    <span
                        className={
                            data.getTime() < Date.now() ? "text-danger" : ""
                        }
                    >
                        {c ? moment(c).format("DD/MM/YYYY") : "-"}
                    </span>
                );
            },
        },
    ];

    function geradorMascaraFinanceira(inputName: keyof any) {
        return (e: ChangeEvent<HTMLInputElement>) => {
            const mask = MoneyReaisFieldMask(e);

            formMethods.setValue(String(inputName), mask);
        };
    }

    const validaDiferenca = (value: string) => {
        const diferencaValue = Number(value.replace(/[^\d.-]/g, ""));
        return diferencaValue === 0 || "O valor da diferença deve ser 0.";
    };

    const validaDesconto = (value: string) => {
        const descontoValue = Number(value.replace(/[^\d.-]/g, ""));
        return descontoValue === 0 || "O valor do Desconto deve ser 0.";
    };

    const validaAditivo = (value: string) => {
        const aditivoValue = Number(value.replace(/[^\d.-]/g, ""));
        return aditivoValue === 0 || "O valor do Aditivo deve ser 0.";
    };

    useEffect(() => {
        if (!getValues("aditivoPrc") && !getValues("descontoPrc")) {
            setValue("aditivoPrc", formatMoneyReais(0));
            setValue("descontoPrc", formatMoneyReais(0));
        }
    }, [getValues, setValue]);

    return (
        <form onSubmit={handleSubmit(SalvarSimulacao)}>
            <h3>Informações da parcela selecionada:</h3>
            <div className="row">
                <div className="col-12 col-sm-3">
                    <label className="mb-0">Data de reparcelamento</label>
                    <input
                        type="date"
                        className={`form-control px-0 p-2`}
                        defaultValue={parcelaReq.DT_CALCULO}
                        onBlur={(e) => {
                            const DT_CALCULO = e.target.value;
                            if (
                                DT_CALCULO &&
                                DT_CALCULO !== parcelaReq.DT_CALCULO
                            ) {
                                setParcelaReq({
                                    DT_CALCULO,
                                });
                            }
                        }}
                    />
                </div>
                <div className="col-12 col-sm-3">
                    <label className="mb-0">Diferença</label>
                    <input
                        name="diferencaPrc"
                        className={`form-control px-0 p-2`}
                        defaultValue={formatMoneyReais(
                            totalGeradas - totalSelecionados
                        )}
                        ref={register({
                            setValueAs: (v) =>
                                Number(MoneyReaisFieldMask.unMask(v)),
                            validate: validaDiferenca,
                        })}
                        onChange={geradorMascaraFinanceira("diferencaPrc")}
                        disabled={!!totalGeradas && !!totalSelecionados}
                    />
                    {errors.diferencaPrc && (
                        <p className="text-danger">
                            {errors.diferencaPrc.message}
                        </p>
                    )}
                </div>
                <div className="col-12 col-sm-3">
                    <label className="mb-0">Desconto</label>
                    <input
                        name="descontoPrc"
                        className={`form-control px-0 p-2 ${
                            errors.descontoPrc ? "is-invalid" : ""
                        }`}
                        defaultValue={formatMoneyReais(0)}
                        ref={(e) => {
                            register(e, {
                                setValueAs: (v) =>
                                    Number(MoneyReaisFieldMask.unMask(v)),
                                validate:
                                    totalGeradas > totalSelecionados
                                        ? validaDesconto
                                        : undefined,
                            });
                        }}
                        onChange={(e) => {
                            const mask = MoneyReaisFieldMask(e);

                            formMethods.setValue(String("descontoPrc"), mask);
                            if (
                                Number(
                                    MoneyReaisFieldMask.unMask(e.target.value)
                                ) +
                                    totalGeradas ===
                                totalSelecionados
                            ) {
                                setValue("diferencaPrc", formatMoneyReais(0));
                            }
                        }}
                    />
                    {errors.descontoPrc && (
                        <p className="text-danger">
                            {errors.descontoPrc.message}
                        </p>
                    )}
                </div>

                <div className="col-12 col-sm-3">
                    <label className="mb-0">Aditivo</label>
                    <input
                        name="aditivoPrc"
                        className={`form-control px-0 p-2 ${
                            errors.aditivoPrc ? "is-invalid" : ""
                        }`}
                        defaultValue={formatMoneyReais(0)}
                        ref={(e) => {
                            register(e, {
                                setValueAs: (v) =>
                                    Number(MoneyReaisFieldMask.unMask(v)),
                                validate:
                                    totalGeradas < totalSelecionados
                                        ? validaAditivo
                                        : undefined,
                            });
                        }}
                        onChange={(e) => {
                            const mask = MoneyReaisFieldMask(e);

                            formMethods.setValue(String("aditivoPrc"), mask);
                            if (
                                totalGeradas -
                                    Number(
                                        MoneyReaisFieldMask.unMask(
                                            e.target.value
                                        )
                                    ) ===
                                totalSelecionados
                            ) {
                                setValue("diferencaPrc", formatMoneyReais(0));
                            }
                        }}
                    />
                    {errors.aditivoPrc && (
                        <p className="text-danger">
                            {errors.aditivoPrc.message}
                        </p>
                    )}
                </div>
            </div>
            <div className="d-flex justify-content-around my-8">
                <div className="d-flex flex-column align-items-center justify-content-center">
                    <h4>Valor Total Parcelas:</h4>
                    <span className="font-size-lg text-muted font-weight-bold">
                        {formatMoneyReais(
                            lstSelecionados?.reduce(
                                (sum, parcela) => sum + parcela.ValorReaj,
                                0.0
                            ) ?? 0
                        )}
                    </span>
                </div>
                <div className="d-flex flex-column align-items-center justify-content-center">
                    <h4>Valor Total Reparcelado:</h4>
                    <span className="font-size-lg text-muted font-weight-bold">
                        {formatMoneyReais(
                            lstSelecionadosParcelasGeradas?.reduce(
                                (sum, parcela) => sum + parcela.ValorReaj,
                                0.0
                            ) ?? 0
                        )}
                    </span>
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-6 mb-4">
                    <h6>Parcelas originais</h6>
                    <Table
                        columns={columnsParcelasOriginaisEReparceladas}
                        data={lstSelecionados ?? []}
                        keyField="NumParc_Prc"
                        noSearch
                        striped
                    />
                </div>
                <div className="col-12 col-md-6 mb-4">
                    <h6>Parcelas geradas</h6>
                    <Table
                        columns={columnsParcelasOriginaisEReparceladas}
                        data={lstSelecionadosParcelasGeradas ?? []}
                        keyField="NumParc_Prc"
                        noSearch
                        striped
                    />
                </div>
            </div>
            <div className="d-flex justify-content-end">
                <button
                    className="btn btn-outline-danger mr-2"
                    type="button"
                    onClick={() => goToStep("condicoesPagamento")}
                    disabled={RealizarRenegociacaoSiengeLoading}
                >
                    Anterior
                </button>
                <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={
                        RealizarRenegociacaoSiengeLoading ||
                        (totalGeradas > totalSelecionados
                            ? Number(
                                  totalGeradas - somaAditivoEDesconto
                              ).toFixed(2) !==
                              Number(totalSelecionados).toFixed(2)
                            : totalGeradas < totalSelecionados
                            ? Number(
                                  totalGeradas + somaAditivoEDesconto
                              ).toFixed(2) !==
                              Number(totalSelecionados).toFixed(2)
                            : Number(
                                  totalGeradas - somaAditivoEDesconto
                              ).toFixed(2) !==
                                  Number(totalSelecionados).toFixed(2) &&
                              Number(totalGeradas + totalSelecionados).toFixed(
                                  2
                              ) !== Number(totalSelecionados).toFixed(2))
                    }
                >
                    {RealizarRenegociacaoSiengeLoading ? (
                        <Spinner size="sm" />
                    ) : (
                        "Salvar Simulação"
                    )}
                </button>
            </div>
        </form>
    );
}
